import { render, staticRenderFns } from "./m-block-acquiring-order-view.vue?vue&type=template&id=1c962902&scoped=true&lang=pug&"
import script from "./m-block-acquiring-order-view.vue?vue&type=script&lang=js&"
export * from "./m-block-acquiring-order-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c962902",
  null
  
)

export default component.exports